import { render } from "./txLoading.vue?vue&type=template&id=f4e45bfa&scoped=true&ts=true"
import script from "./txLoading.vue?vue&type=script&lang=ts"
export * from "./txLoading.vue?vue&type=script&lang=ts"

import "./txLoading.vue?vue&type=style&index=0&id=f4e45bfa&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4e45bfa"]])

export default __exports__